import React from 'react';
import { QUEST_CONTENT_MAX_SIZE } from '../../../data/constants/quests';
import { isValidAttachment } from '../../../data/filters/attachmentsFilters';
import resolvePath from '../../../misc/resolvePath';
import { dialogAlert } from '../../elements/Dialog/dialogs';
import EditableAttachmentsList from '../../elements/EditableAttachmentsList/EditableAttachmentsList';
import Scrollable from '../../elements/Scrollable';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import ISQAOpen from '../../validate/ISQAOpen';
import EventImageAttachment from '../EventAttachments/EventImageAttachment';
import Screen from './../Screen';
import connectQuests from './common/connectQuests';
import PostContentToolbar from './common/PostContentToolbar/PostContentToolbar';

export class EventQuestsQuestionPostAnswer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            answer: props.answer ? props.answer.content || '' : '',
            busy: false,
            title: this.props.i18n['label.new.reply'],
            addAttachments: [],
            attachments: _(props).get('answer.attachments', []),
            removeAttachments: [],
            hideAttachments: false,
        };
    }
    componentDidMount() {
        this.state.mounted = true;
        if (!this.props.answer && this.el) {
            this.el.querySelector('textarea').focus();
        }
    }
    componentWillUnmount() {
        this.state.mounted = false;
    }
    render() {
        if (this.state.previewAttachment) {
            return (
                <EventImageAttachment
                    {...this.props}
                    file={this.state.previewAttachment.full_url ? null : this.state.previewAttachment}
                    src={this.state.previewAttachment.full_url}
                    allowDelete={!this.props.answer}
                    onReturnClick={this.handleCloseAttachmentPreview.bind(this)}
                    onDelete={this.handleDeleteAttachment.bind(this, this.state.previewAttachment)}
                />
            );
        }

        let { i18n, event } = this.props,
            header = (
                <TopBarEvent event={event} returnURL="..">
                    {this.state.title}
                </TopBarEvent>
            ),
            footer = (
                <div>
                    <PostContentToolbar
                        color={event.settings.primary_color}
                        allowDelete={!!this.props.answer}
                        disableSubmit={this.state.busy}
                        photoUploadEnabled={this.props.photoUploadEnabled}
                        videoUploadEnabled={this.props.videoUploadEnabled}
                        onFilesSelected={this.handleFilesSelected.bind(this)}
                        onDelete={this.handleDeleteAnswer.bind(this)}
                    />
                    <EditableAttachmentsList
                        className={this.state.hideAttachments ? 'hideOnSmallScreens' : ''}
                        attachments={[...this.state.attachments, ...this.state.addAttachments]}
                        photoUploadEnabled={this.props.photoUploadEnabled}
                        videoUploadEnabled={this.props.videoUploadEnabled}
                        onClick={this.handleAnswerAttachmentClicked.bind(this)}
                        onDelete={this.handleDeleteAttachment.bind(this)}
                    />
                </div>
            );

        // console.log(this.props);

        return (
            <form onSubmit={this.handleSubmit.bind(this)}>
                <Screen header={header} footer={footer}>
                    <Scrollable>
                        <div ref={(el) => (this.el = el)} className="content fill-container graybg">
                            <textarea
                                className="fill-container form-control"
                                value={this.state.answer}
                                maxLength={QUEST_CONTENT_MAX_SIZE}
                                onChange={this.handleAnswerChange.bind(this)}
                                onFocus={this.handleTextareaFocusChange.bind(this, true)}
                                onBlur={this.handleTextareaFocusChange.bind(this, false)}
                            />
                        </div>
                    </Scrollable>
                </Screen>
            </form>
        );
    }
    handleTextareaFocusChange(textareaIsFocused) {
        this.setState({ hideAttachments: textareaIsFocused });
    }
    handleAnswerChange(event) {
        this.setState({ answer: event.target.value });
    }
    handleDeleteAttachment(attachment) {
        this.setState({
            previewAttachment: null,
            addAttachments: this.state.addAttachments.filter((obj) => obj != attachment),
            attachments: this.state.attachments.filter((obj) => obj != attachment),
            removeAttachments: this.state.attachments.find((obj) => obj == attachment) ? [...this.state.removeAttachments, attachment] : this.state.removeAttachments,
        });
    }
    handleCloseAttachmentPreview() {
        this.setState({ previewAttachment: null });
    }
    handleAnswerAttachmentClicked(attachment) {
        this.setState({ previewAttachment: attachment });
    }
    handleFilesSelected(files) {
        this.setState({
            addAttachments: [...this.state.addAttachments, ...files],
        });
    }
    async handleSubmit(e) {
        e.preventDefault();

        let answer = this.state.answer.trim(),
            anonymous = false;

        if (!answer.length) {
            return await dialogAlert(this.props.i18n['message.question_quality_warning']);
        } else {
            app.store.dispatch(app.actions.ui.busy());
            this.setState({ busy: true });

            const newAttachments = this.state.addAttachments.filter((attachment) =>
                isValidAttachment(attachment.type || attachment.mimetype, this.props.photoUploadEnabled, this.props.videoUploadEnabled)
            );

            Promise.all(
                newAttachments.map((file) => {
                    return app.api.events.uploadUserEventFile(this.props.eventId, file);
                })
            )
                .then((newAttachments) => {
                    return this.submitAnswer(answer, anonymous, [...this.state.attachments.map((attachment) => attachment.uid), ...newAttachments]);
                })
                .then(() => {
                    app.history.push(resolvePath(app.history.location.pathname, '..'));
                })
                .catch((e) => {
                    console.error(e);
                    // TODO: handle received error messages
                })
                .then(() => {
                    app.store.dispatch(app.actions.ui.free());
                    if (this.state.mounted) {
                        this.setState({ busy: false });
                    }
                });
        }
    }
    handleDeleteAnswer() {
        this.setState({ busy: true });
        app.api.questions
            .deleteAnswer(this.props.eventId, this.props.questionId, this.props.answerId)
            .then(() => {
                console.log("Refetching question answers to skip fetching all answers next when the timestamps don't match");
                return app.api.questions.fetchAnswers(this.props.eventId, this.props.questionId);
            })
            .then(() => {
                app.history.push(resolvePath(app.history.location.pathname, '..'));
            });
    }
    submitAnswer(answer, anonymous, attachments) {
        return app.api.questions.postAnswer(this.props.eventId, this.props.questionId, answer, anonymous, attachments);
    }
}

const ConnectedComponent = connectQuests(EventQuestsQuestionPostAnswer);

export default (props) => (
    <ISQAOpen eventId={props.match.params.eventId}>
        <ConnectedComponent {...props.match.params} />
    </ISQAOpen>
);
